export default {"src":"/_next/static/image/public/images/ic_video_consult_circle.30123419af534076de9272b2c2b35cd0.svg","height":42,"width":42};